import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { QuoteForm } from "@/components/QuoteForm";
import { Checkbox } from "@/components/ui/checkbox";

type Props = { eventType: any; answers?: any; consented: boolean; consentText: string; onlyIds?: string[]; onSaved: (res: any) => void; submitLabel?: string };

export function TypeProfileForm({ eventType, answers, consented, consentText, onlyIds, onSaved, submitLabel }: Props) {
  const [agree, setAgree] = useState(consented);
  const fields = onlyIds ? eventType.questions.filter((q: any) => onlyIds.includes(q.id)) : eventType.questions;
  const save = async (a: any) => {
    if (!agree) return void toast.error("Please tick the box to share these answers with vendors you scan");
    try {
      const { data } = await api.put(`/me/event-profiles/${eventType.id}`, { answers: a, consent: agree });
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <QuoteForm form={{ fields }} initial={answers} onSubmit={save} submitLabel={submitLabel || "Save my answers"} testid={`type-profile-form-${eventType.id}`}>
      {!consented && (
        <label className="flex gap-3 rounded-xl border border-emerald-200 bg-emerald-50/50 p-3 text-xs leading-relaxed text-slate-700" data-testid="type-profile-consent">
          <Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} className="mt-0.5" data-testid="type-profile-consent-checkbox" />
          <span><ShieldCheck className="mr-1 inline h-3.5 w-3.5 text-emerald-600" />{consentText}</span>
        </label>
      )}
    </QuoteForm>
  );
}
